import instance from "../../api/Api";

/**
 *
 * @returns array of notifications list
 */
export const getNotifications = async () => {
  try {
    const { data } = await instance.get("v1/notifications/");
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 *
 *
 * @returns details of selected notification
 */
export const getNotification = () => {
  return instance.get(`v1/notifications/alerts/`);
};

/**
 *
 * @param {object} data pari , title , exchanges and etc.
 * @returns notification created
 */
export const createNotification = (data) => {
  return instance.post(`v1/notification/`, data);
};

/**
 *
 * @param {string} notif_id - The ID of the notification to delete.
 * @return {Promise} A Promise that resolves with the result of the deletion.
 */
export const deleteNotifications = (notif_id) => {
  return instance.delete(`v1/notifications/${notif_id}/`);
};

/**
 * Toggles the active status of a notification.
 *
 * @param {string} notif_id - The ID of the notification to toggle.
 * @return {Promise} A Promise that resolves with the result of the toggle operation.
 */
export const toggleNotification = (notif_id) => {
  return instance.post(`v1/notifications/${notif_id}/toggle-active`);
};
